<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="__wraper_">
          <div class="_address">
             <div class="container-page">
              <div style="font-weight: 700; color: #1D3354;" class="header">My Address</div>
              <div class="content">
                <div class="content-header">
                  <button class="button__redcorporite" @click="toFormAddress">
                    + Add New Address
                  </button>
                  <b-input class="col-md-3" :placeholder="`Input Company Name`"
                  @input="debouncedOnChange" v-model="search"></b-input>
                </div>
                <AddressCard :currentPage="currentPage" :mode="'setting'" :isFiltering="isFiltering" />
                <div class="row m-0 paginationCustom pt-3">
                  <div class="col-md-12 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    >
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import AddressCard from '@/components/settings/AddressCard.vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  name: '',
  components: {
    Sidebar,
    AddressCard
  },
  data () {
    return {
      searchItem: '',
      currentPage: 1,
      totalRows: 0,
      perPage: 4,
      isFiltering: false,
      dataAddress: [],
      globalBillingData: '',
      search: ''
    }
  },
  computed: {
    debouncedOnChange () {
      return _.debounce(this.filterOnChange, 700)
    },
    ...mapGetters({
      addressList: 'address/addressList',
      addressListFilter: 'address/addressListFilter',
      billingAddressGlobal: 'address/billingAddressGlobal'
    })
  },
  mounted () {
    this.fetchAddressList()
  },
  created () {
    this.$eventHub.$on('fetch-all-address', this.fetchAddressList())
  },
  beforeDestroy () {
    this.$eventHub.$off('fetch-all-address')
  },
  methods: {
    filterOnChange () {
      this.searchItem = this.search
    },
    async fetchAddressList () {
      this.isFiltering = false
      await this.$store.dispatch('address/FETCH_ALL_ADDRESS', {page: this.currentPage, perPage: this.perPage})
    },
    async fetchAddressListFilter (payload) {
      this.isFiltering = true
      await this.$store.dispatch('address/FETCH_ALL_ADDRESS_FILTER', payload)
    },
    async toFormAddress () {
      await this.$store.dispatch('auth/FETCH_DIAL_COUNTRY_CODE')
      await this.$store.dispatch('settingCompany/FETCH_COUNTRIES')
      this.$eventHub.$emit('dialog-form-address', {title: 'Add Address', currentPage: this.currentPage})
    }
  },
  watch: {
    addressList (data) {
      if (data) {
        this.totalRows = data.totalRecords
      }
    },
    addressListFilter (data) {
      if (data) {
        this.totalRows = data.totalRecords
      }
    },
    currentPage (data) {
      if (data) {
        if (this.searchItem) {
          const payload = {
            page: this.currentPage,
            filter: 'company-name',
            key: this.searchItem,
            perpage: this.perpage
          }
          this.fetchAddressListFilter(payload)
        } else {
          this.fetchAddressList()
        }
      }
    },
    searchItem (data) {
      if (data) {
        const payload = {
          page: this.currentPage,
          filter: 'company-name',
          key: data,
          perpage: this.perpage
        }
        this.fetchAddressListFilter(payload)
      } else {
        this.fetchAddressList()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/settings/Address.vue